import { render, staticRenderFns } from "./DeleteBorrower.vue?vue&type=template&id=031e167d&"
import script from "./DeleteBorrower.vue?vue&type=script&lang=js&"
export * from "./DeleteBorrower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports